module.exports = __webpack_public_path__ + "static/media/bars.025711ab.svg";